import React, { useEffect, Component } from "react";
import LayoutOperation from "../../../components/layout_operation";
import { DatePicker, Select, Input, Modal, Tooltip, Table, Progress, Spin } from "antd";
import ChartJobRemain from "../../../ui/chart/job_remain";

import Cookies from "js-cookie";
import Api from "../../../services/ServiceApi";


// import { ChartPostOnAir } from "../../../ui/chart/post_on_air";
import ChartPostOnair from "../../../ui/chart/post_on_air";
import ChartProduction from "../../../ui/chart/chart_production";
import ChartPlaylist from "../../../ui/chart/chart_playlist";



import ChartClaim from "../../../ui/chart/chart_claim";
import ChartPM from "../../../ui/chart/chart_pm";
import ChartAQM from "../../../ui/chart/chart_aqm";
import ChartQC from "../../../ui/chart/chart_qc";
import ChartEngineer from "../../../ui/chart/chart_engineer";
import { Link } from "react-router-dom";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;
const ColorBasic = ["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583", '#4E6641',
  '#BEBB56',
  '#FFBC47',
  '#AC3E1A',
  '#6F0A12',
  '#4D2221',
  '#6A4531',
  '#DA6B42',
  '#8F4150',
  '#DA6B42',
  '#624489',
  '#1A3164',
  '#579E98',
  '#ACA57B',
  '#7F92AE', "#FF0000"];


class Dashboard extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      data_dashbord: [],
      columns_equipment: [
        {
          title: "Material ID",
          dataIndex: "material_id",
          key: "material_id",
        },
        {
          title: "Material Name",
          dataIndex: "material_name",
          key: "material_name",
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Unit Code",
          dataIndex: "unit_code",
          key: "unit_code",
        },
      ],
      data_team_ranking: [
        {
          team_name: "CG",
          name: "",
          job: "110",
          progess_sla: "100",
        },
        {
          team_name: "Media-Co",
          name: "",
          job: "101",
          progess_sla: "100",
        },
        {
          team_name: "Photo",
          name: "",
          job: "99",
          progess_sla: "65",
        },
        {
          team_name: "Report",
          name: "",
          job: "129",
          progess_sla: "100",
        },
        {
          team_name: "MA (BKK)",
          name: "",
          job: "114",
          progess_sla: "70",
        },
        {
          team_name: "MA (NTW)",
          name: "",
          job: "113",
          progess_sla: "80",
        },
        {
          team_name: "AQM",
          name: "",
          job: "98",
          progess_sla: "100",
        },
      ],
      data_sla_claim: [
        {
          name: "PBTV",
          progess_sla: "100",
        },
        {
          name: "Nationwide",
          progess_sla: "100",
        },
        {
          name: "Bangkok Jam1&2",
          progess_sla: "95",
        },
        {
          name: "In Mall",
          progess_sla: "90",
        },
        {
          name: "Digital MRT",
          progess_sla: "85",
        },
        {
          name: "BigC",
          progess_sla: "80",
        },
        {
          name: "Singnature",
          progess_sla: "75",
        },
      ],
      data_sla_photo: [
        {
          name: "QC",
          progess_sla: "95",
        },
        {
          name: "Photo",
          progess_sla: "90",
        },
      ],
      data_sla_report: [
        {
          name: "Report",
          progess_sla: "100",
        },
      ],
      data_sla_post: [
        {
          name: "Post",
          progess_sla: "100",
        },
      ],
      data_top_asset: [
      ],
      data_job_summary:
        [{
          name: "Post On Air",
          data: [26, 38, 67, 87, 89, 132, 142, 179, 190, 221, 260, 353, 485, 498, 524, 557, 558, 579, 612, 628, 640, 647, 659, 733, 743, 834, 839, 874, 876, 997]
        },
        {
          name: "Production",
          data: [114, 119, 176, 200, 206, 221, 222, 233, 289, 302, 345, 386, 386, 395, 404, 405, 453, 454, 487, 553, 635, 657, 719, 767, 797, 826, 833, 865, 915, 957]
        },
        {
          name: "Playlist",
          data: [6, 22, 51, 66, 67, 152, 182, 186, 225, 326, 330, 356, 424, 438, 475, 501, 543, 629, 633, 664, 685, 694, 703, 741, 791, 857, 896, 957, 965, 990]

        },
        {
          name: "Report",
          data: [89, 108, 109, 148, 164, 196, 204, 264, 354, 356, 471, 478, 534, 558, 581, 599, 607, 746, 761, 771, 782, 850, 857, 893, 924, 927, 933, 944, 973, 990]
        },
        ],
      data_job_summary_ma:
        [{
          name: "Claim",
          data: [26, 38, 67, 87, 89, 132, 142, 179, 190, 221, 260, 353, 485, 498, 524, 557, 558, 579, 612, 628, 640, 647, 659, 733, 743, 834, 839, 874, 876, 997]
        },
        {
          name: "PM",
          data: [114, 119, 176, 200, 206, 221, 222, 233, 289, 302, 345, 386, 386, 395, 404, 405, 453, 454, 487, 553, 635, 657, 719, 767, 797, 826, 833, 865, 915, 957]
        },
        {
          name: "AQM",
          data: [6, 22, 51, 66, 67, 152, 182, 186, 225, 326, 330, 356, 424, 438, 475, 501, 543, 629, 633, 664, 685, 694, 703, 741, 791, 857, 896, 957, 965, 990]

        },
        {
          name: "QC&Photo",
          data: [89, 108, 109, 148, 164, 196, 204, 264, 354, 356, 471, 478, 534, 558, 581, 599, 607, 746, 761, 771, 782, 850, 857, 893, 924, 927, 933, 944, 973, 990]
        },
        ],
      data_view_all: [{
        asset_type: "Signature",
        color: "#A83D8E",
        total_job: "359"
      },
      {
        asset_type: "BigC",
        color: "#482080",
        total_job: "75"
      },
      {
        asset_type: "Digital MRT",
        color: "#2269AE",
        total_job: "51"
      },
      {
        asset_type: "In Mall",
        color: "#ECC419",
        total_job: "44"
      },
      {
        asset_type: "Bangkok Jam1&2",
        color: "#5F7C36",
        total_job: "20"
      },
      {
        asset_type: "Nationwide",
        color: "#DD8524",
        total_job: "10"
      },
      {
        asset_type: "PBTV",
        color: "#1C3583",
        total_job: "10"
      },
      ],
      modal_view_all: false,
      title_modal: "",
      lodding: false,
      date_filter: [],
      disable_chart_label: {
        post_on_air: false,
        production: false,
        playlist: false,
        report: false,
        claim: false,
        pm: false,
        aqm: false,
        qc_photo: false,
        engineer: false,
      },
      status_chart: "",
      colum_asset: [
        {
          title: '',
          dataIndex: 'color',
          width: 30,
          render: (item) =>
            item === "-" ? null : <span className="statusAsset" style={{ backgroundColor: item, marginLeft: "10px" }}>{""}</span>
          ,
        },
        {
          title: 'Asset Type',
          dataIndex: 'asset_type',

        },
        {
          title: 'Total Jobs',
          dataIndex: 'total_job',
        },
      ],
      loading: false,
      loading_refresh_data: false,
    };
  }
  async componentDidMount() {
    var setdate = [];
    let now = new Date();
    let next30days = new Date(now.setDate(now.getDate() - 30));
    setdate.push(next30days.toUTCString());
    setdate.push(new Date());

    this.filterData(setdate);
    // this.setState({
    //   lodding: true
    // })
  }

  filterDataProcess = async (date) => {
    const get_detail = await Api.post("planb_dashboard_airport", {
      "company_id": Cookies.get("companyid"),
      "operator_id": 4,
      "project_id": Cookies.get("project_id"),
      "date_start": moment(date[0]).format("YYYY-MM-DD"),
      "date_end": moment(date[1]).format("YYYY-MM-DD")
      // "date_start": "2021-03-01",
      // "date_end": "2021-03-28",
    });
    console.log(get_detail.data.data);
    if (get_detail.data.data.top10asset.length > 0 && get_detail.data.data.top10asset.length > 10) {

      for (let i = 0; i < 10; i++) {

        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    }
    else if (get_detail.data.data.top10asset.length > 0 && get_detail.data.data.top10asset.length < 10) {
      for (let i = 0; i < get_detail.data.data.top10asset.length; i++) {

        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    }
    this.setState({
      data_dashbord: get_detail.data.data,
      lodding: true
    });
  }

  filterData = async (date) => {
    await this.setState({
      data_top_asset: [],
      loading_refresh_data: true,
    })
    if (date != undefined) {
      await this.filterDataProcess(date);
    } else {
      var setdate = [];
      let now = new Date();
      let next30days = new Date(now.setDate(now.getDate() - 30));
      setdate.push(next30days.toUTCString());
      setdate.push(new Date());
      await this.filterDataProcess(setdate);
    }
    await this.setState({
      loading_refresh_data: false,
    })
  }
  ondisable_chart_label = (value, data) => {
    this.state.disable_chart_label[value] = !this.state.disable_chart_label[value];
    this.setState({
      disable_chart_label: this.state.disable_chart_label
    })
  }
  openModal = (modal, tital, data) => {
    var setData = [];
    var TotalData = 0;
    if (data.series === undefined) {
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        setData.push({
          asset_type: data[i]["asset_type_name"] === undefined ? data[i]["job_category_name"] === undefined ? data[i]["job_category_name"] : data[i]["job_category_name"] : data[i]["asset_type_name"],
          color: ColorBasic[i],
          total_job: data[i]["count_job"]
        })
        TotalData += data[i]["count_job"];
      }
      setData.push({
        asset_type: "Total",
        color: "-",
        total_job: TotalData
      })
      this.setState({ modal_view_all: modal, title_modal: tital, data_view_all: setData });
    }
    else {
      for (let i = 0; i < data.series.length; i++) {
        setData.push({
          asset_type: data["labels"][i],
          color: ColorBasic[i],
          total_job: data["series"][i]
        })
        TotalData += data["series"][i];
      }
      setData.push({
        asset_type: "Total",
        color: "-",
        total_job: TotalData
      })
      this.setState({ modal_view_all: modal, title_modal: tital, data_view_all: setData });
    }
  }
  render() {
    return (
      <>
        {this.state.lodding === true ?
          <>
            <Spin spinning={this.state.loading_refresh_data}>
              <Modal
                title={null}
                centered
                visible={this.state.modal_view_all}
                footer={null}
                closable={false}
                width={1000}
              >
                <div className="row">
                  <div className="col-6">
                    {/* this.state.disable_chart_label["post_on_air"] */}
                    <div style={{ marginTop: "20%" }} >
                      {this.state.title_modal === "Post On Air" ? <ChartPostOnair data={[]} fact={true} /> : null}
                      {this.state.title_modal === "Production" ? <ChartProduction data={[]} fact={true} /> : null}
                      {this.state.title_modal === "Playlist" ? <ChartPlaylist data={[]} fact={true} /> : null}
                      {this.state.title_modal === "Report" ? <ChartPlaylist data={[]} fact={true} /> : null}
                      {this.state.title_modal === "Claim" ? <ChartClaim data={this.state.data_dashbord["circle_claim"]} fact={true} /> : null}
                      {this.state.title_modal === "PM" ? <ChartPM data={this.state.data_dashbord["pm"]} fact={true} /> : null}
                      {/* {this.state.title_modal === "AQM" ? <ChartAQM data={this.state.data_dashbord["aqm"]} fact={true} /> : null} */}
                      {this.state.title_modal === "QC&Photo" ? <ChartQC data={this.state.data_dashbord["photo_report"]} fact={true} /> : null}
                      {this.state.title_modal === "Engineer" ? <ChartEngineer data={[]} fact={true} /> : null}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="text-center" >
                      <h3 className="font-mont-sb fs-18 c-blue mt-3 text-left">
                        {this.state.title_modal}
                      </h3>
                      <Table columns={this.state.colum_asset} dataSource={this.state.data_view_all} pagination={false} scroll={{ y: 400 }} />

                      <button
                        onClick={() => this.setState({ modal_view_all: false })}
                        className="btn btn-secondary"
                        style={{ color: "#0500A3" }}
                      >
                        Close
                      </button>

                    </div>
                  </div>
                </div>

              </Modal>
              <div style={this.props.status === 0 ? null : { marginTop: "-4rem" }}>
                <div className="wrapper-header d-flex" style={{ height: "284px" }}>
                  <div className="container-fluid">
                    <div className="row align-items-center mt-3">
                      <div className="ant-col ant-col-xs-24 ant-col-xl-24" style={{ textAlign: "left", marginLeft: "20px" }}>
                        <img
                          src={Api.absoluteUrl("/icon/dashboard_white.svg")}
                          className="mr-3"
                          alt=""
                        />
                        <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                          Airport Dashboard
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wrapper-body" style={{ marginTop: "-210px" }}>
                  <div className="container-fluid">
                    <div className="card-dashboard mb-4">

                      <div className="row ">
                        <div className="col-sm-auto col-md-2 m-2">
                          <Select
                            placeholder="Please select"
                            optionFilterProp="children"
                            className="font-mont-r fs-12"
                            value=""
                            style={{ width: "100%" }}
                          >
                            <Option value="">Date</Option>
                          </Select>
                        </div>
                        <div className="col-sm-auto col-md-4 m-2">
                          <RangePicker
                            onChange={(e) => this.filterData(e)}
                            style={{ color: "#000f9f ", width: "100%" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-sm-auto col-md-8">
                        <div className="row mb-3">
                          <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard" style={{ padding: "10px", backgroundColor: "#E5E7EB" }}>
                              <h3 className="font-mont-sb fs-16 c-blue">Clean: Digital</h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >

                                <ChartClaim data={this.state.data_dashbord["circle_clean_digital"]} fact={this.state.disable_chart_label["circle_clean_digital"]} />

                              </div>
                              <div style={{ textAlign: "right" }}>
                                <button
                                  className="butviewall mr-2"
                                  style={this.state.disable_chart_label["post_on_air"] ? { color: "#FFFFFF" } :
                                    { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                  }
                                  onClick={() =>
                                    this.ondisable_chart_label("post_on_air")
                                  }
                                >
                                  {this.state.disable_chart_label["post_on_air"] ? "ON" : "OFF"}
                                </button>
                                <button
                                  className="butviewall"
                                  style={{ color: "#fff" }}
                                  onClick={() => this.openModal(true, "Clean: Digital",
                                    {
                                      labels: ['PBTV', 'Nationwide', 'Bangkok Jam1&2', 'In Mall', 'Digital MRT', 'BigC', 'Signature'],
                                      series: [10, 10, 20, 44, 51, 75, 359]
                                    }
                                  )}
                                >

                                  view more..
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard" style={{ padding: "10px", backgroundColor: "#E5E7EB" }}>
                              <h3 className="font-mont-sb fs-16 c-blue">Clean: Static</h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartClaim data={this.state.data_dashbord["circle_clean_static"]} fact={this.state.disable_chart_label["circle_clean_static"]} />
                              </div>
                              <div style={{ textAlign: "right" }}>
                                <button
                                  className="butviewall mr-2"
                                  style={this.state.disable_chart_label["production"] ? { color: "#FFFFFF" } :
                                    { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                  }
                                  onClick={() =>
                                    this.ondisable_chart_label("production")
                                  }
                                >

                                  {this.state.disable_chart_label["production"] ? "ON" : "OFF"}
                                </button>
                                <button
                                  className="butviewall"
                                  style={{ color: "#fff" }}
                                  onClick={() => this.openModal(true, "Production", {
                                    labels: ['Animate', 'Complate File', 'Digital MRT', 'In Mall'],
                                    series: [52, 60, 150, 747]
                                  })}
                                >

                                  view more..
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard" style={{ padding: "10px", backgroundColor: "#E5E7EB" }}>
                              <h3 className="font-mont-sb fs-16 c-blue">Post: Digital</h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartClaim data={this.state.data_dashbord["circle_post_digital"]} fact={this.state.disable_chart_label["circle_post_digital"]} />
                              </div>
                              <div style={{ textAlign: "right" }}>
                                <button
                                  className="butviewall mr-2"
                                  style={this.state.disable_chart_label["Post: Digital"] ? { color: "#FFFFFF" } :
                                    { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                  }
                                  onClick={() =>
                                    this.ondisable_chart_label("playlist")}
                                >
                                  {this.state.disable_chart_label["playlist"] ? "ON" : "OFF"}
                                </button>
                                <button
                                  className="butviewall"
                                  style={{ color: "#fff" }}
                                  onClick={() => this.openModal(true, "Playlist", {
                                    series: [489, 700, 1386, 1694, 2046, 2232, 2514, 2556, 2958, 3019, 3806, 3841, 4011, 4037, 4653, 5137, 5666, 5728, 5863, 5935, 6588, 6825, 7446],
                                    labels: ['PBTV',
                                      'Nationwide',
                                      'Bangkok Jam 1',
                                      'Bangkok Jam 2',
                                      'In Mall',
                                      'Central Network',
                                      'Icon Siam',
                                      '6 CBD',
                                      'Motion Block 1',
                                      'Motion Block 2',
                                      'EMP-EMQ',
                                      'PI9',
                                      'Digital MRT',
                                      'The Prime 9',
                                      'PIDa MRT+Digital Wall Asoke',
                                      'The Base',
                                      'BigC',
                                      'The Panoramix',
                                      'Twin Tube+',
                                      'Eastin',
                                      'Show DC',
                                      'Twin Tube',
                                      'Victory Monument']
                                  })
                                  }
                                >

                                  view more..
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard" style={{ padding: "10px", backgroundColor: "#E5E7EB" }}>
                              <h3 className="font-mont-sb fs-16 c-blue">Post: Static</h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartClaim data={this.state.data_dashbord["circle_post_static"]} fact={this.state.disable_chart_label["circle_post_static"]} />
                              </div>
                              <div style={{ textAlign: "right" }}>
                                <button
                                  className="butviewall mr-2"
                                  style={this.state.disable_chart_label["report"] ? { color: "#FFFFFF" } :
                                    { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                  }
                                  onClick={() =>
                                    this.ondisable_chart_label("report")
                                  }
                                >
                                  {this.state.disable_chart_label["report"] ? "ON" : "OFF"}
                                </button>
                                <button
                                  className="butviewall"
                                  style={{ color: "#fff" }}
                                  onClick={() => this.openModal(true, "Report", {
                                    series: [489, 700, 1386, 1694, 2046, 2232, 2514, 2556, 2958, 3019, 3806, 3841, 4011, 4037, 4653, 5137, 5666, 5728, 5863, 5935, 6588, 6825, 7446],
                                    labels: ['PBTV',
                                      'Nationwide',
                                      'Bangkok Jam 1',
                                      'Bangkok Jam 2',
                                      'In Mall',
                                      'Central Network',
                                      'Icon Siam',
                                      '6 CBD',
                                      'Motion Block 1',
                                      'Motion Block 2',
                                      'EMP-EMQ',
                                      'PI9',
                                      'Digital MRT',
                                      'The Prime 9',
                                      'PIDa MRT+Digital Wall Asoke',
                                      'The Base',
                                      'BigC',
                                      'The Panoramix',
                                      'Twin Tube+',
                                      'Eastin',
                                      'Show DC',
                                      'Twin Tube',
                                      'Victory Monument']
                                  })
                                  }
                                >
                                  view more..
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="ant-col ant-col-xs-24 ant-col-xl-24" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard ">
                              <h3 className="font-mont-sb fs-16 c-blue">
                                Job Summary Customer Service
                              </h3>
                              <div>
                                <ChartJobRemain
                                  data={this.state.data_dashbord["line_summary_customer_service"]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="row mb-4">
                              <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-16 c-blue">Claim: Digital</h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartClaim data={this.state.data_dashbord["circle_claim_digital"]} fact={this.state.disable_chart_label["circle_claim_digital"]} />
                                  </div>
                                  <div style={{ textAlign: "right" }}>
                                    <button
                                      className="butviewall mr-2"
                                      style={this.state.disable_chart_label["claim"] ? { color: "#FFFFFF" } :
                                        { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                      }
                                      onClick={() =>
                                        this.ondisable_chart_label("claim")
                                      }
                                    >

                                      {this.state.disable_chart_label["claim"] ? "ON" : "OFF"}
                                    </button>
                                    <button
                                      className="butviewall"
                                      style={{ color: "#fff" }}
                                      onClick={() => this.openModal(true, "Claim", this.state.data_dashbord["circle_claim"])}
                                    >

                                      view more..
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-16 c-blue">Claim: Static</h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartClaim data={this.state.data_dashbord["circle_claim_static"]} fact={this.state.disable_chart_label["circle_claim_static"]} />
                                  </div>
                                  <div style={{ textAlign: "right" }}>
                                    <button
                                      className="butviewall mr-2"
                                      style={this.state.disable_chart_label["pm"] ? { color: "#FFFFFF" } :
                                        { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                      }
                                      onClick={() =>
                                        this.ondisable_chart_label("pm")
                                      }
                                    >

                                      {this.state.disable_chart_label["pm"] ? "ON" : "OFF"}
                                    </button>
                                    <button
                                      className="butviewall"
                                      style={{ color: "#fff" }}
                                      onClick={() => this.openModal(true, "PM", this.state.data_dashbord["pm"])}
                                    >

                                      view more..
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-16 c-blue">Report: Digital</h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartClaim data={this.state.data_dashbord["circle_report_digital"]} fact={this.state.disable_chart_label["circle_report_digital"]} />
                                  </div>
                                  <div style={{ textAlign: "right" }}>
                                    <button
                                      className="butviewall mr-2"
                                      style={this.state.disable_chart_label["aqm"] ? { color: "#FFFFFF" } :
                                        { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                      }
                                      onClick={() =>
                                        this.ondisable_chart_label("aqm")
                                      }
                                    >
                                      {this.state.disable_chart_label["aqm"] ? "ON" : "OFF"}
                                    </button>
                                    <button
                                      className="butviewall"
                                      style={{ color: "#fff" }}
                                      onClick={() => this.openModal(true, "AQM", this.state.data_dashbord["aqm"])}
                                    >
                                      view more..
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="ant-col ant-col-xs-24 ant-col-xl-6" style={{ padding: "5px 5px 5px 5px" }}>
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-16 c-blue">
                                    Report: Static
                                  </h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartClaim data={this.state.data_dashbord["circle_post_static"]} fact={this.state.disable_chart_label["circle_post_static"]} />
                                  </div>
                                  <div style={{ textAlign: "right" }}>
                                    <button
                                      className="butviewall mr-2"
                                      style={this.state.disable_chart_label["qc_photo"] ? { color: "#FFFFFF" } :
                                        { backgroundColor: "#ededed", color: "rgb(171 162 162)" }
                                      }
                                      onClick={() =>
                                        this.ondisable_chart_label("qc_photo")
                                      }
                                    >

                                      {this.state.disable_chart_label["qc_photo"] ? "ON" : "OFF"}
                                    </button>
                                    <button
                                      className="butviewall"
                                      style={{ color: "#fff" }}
                                      onClick={() => this.openModal(true, "QC&Photo", this.state.data_dashbord["photo_report"])}
                                    >

                                      view more..
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="ant-col ant-col-xs-24 ant-col-xl-24" style={{ padding: "5px 5px 5px 5px" }}>
                            <div className="card-dashboard">
                              <h3 className="font-mont-sb fs-16 c-blue">
                                Job Summary Maintenance Service
                              </h3>
                              <div>
                                <ChartJobRemain
                                  data={this.state.data_dashbord["line_summary_ma_service"]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-auto col-sm-4 w-100" style={{ marginTop: "5px" }}>
                        <div className="wrapper-dashboard-right">
                          <div className="head">
                            <div className="row mb-2" style={{ padding: "0 20px" }}>
                              <div className="col-6">
                                <span className="font-mont-m fs-14 c-white">
                                  Team Management
                                </span>
                              </div>
                              <div className="col-6" style={{ textAlign: "right" }}>
                                <span className="font-mont-m fs-14 c-white">
                                  {this.state.data_dashbord["team_management"][0].working}  online

                                </span>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col text-center">
                                <h4 className="font-mont-sb fs-26 c-white m-0">{this.state.data_dashbord["team_management"][0].employee} </h4>
                                <span className="font-mont-m fs-14 c-white">
                                  Employee
                                </span>
                              </div>
                              <div
                                className="col text-center"
                                style={{
                                  borderLeft: "1px solid rgba(255, 255, 255, 0.25)",
                                }}
                              >
                                <h4 className="font-mont-sb fs-26 c-white m-0">{this.state.data_dashbord["team_management"][0].team_qty}</h4>
                                <span className="font-mont-m fs-14 c-white">Team</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="ant-col ant-col-xs-24 ant-col-xl-24" style={{ textAlign: "right" , paddingLeft: "15px", paddingRight: "15px" }}>
                            <div className="card-dashboard">
                              <h3
                                className="font-mont-sb fs-16 c-blue"
                                style={{ borderBottom: "1px solid" }}
                              >
                                On time SLA rate : Employee
                              </h3>
                              <div className="row mt-2">
                                <div className="col-3">
                                  <span className="font-mont-m fs-10 ">TEAM</span>
                                </div>
                                <div className="col-9">
                                  <div className="row">
                                    <div className="col-4">
                                      {/* <span className="font-mont-m fs-10 ">NAME</span> */}
                                    </div>
                                    <div className="col-4">
                                      <span className="font-mont-m fs-10 ">JOB</span>
                                    </div>
                                    <div
                                      className="col-4"
                                      style={{ textAlign: "center" }}
                                    >
                                      <span className="font-mont-m fs-10 ">On time SLA</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.data_dashbord["sla_employee"].map((item, index) => (
                                <div className="row mt-1">
                                  <div className="col-3">
                                    <span className="font-mont-m fs-10 c-blue fs-12" style={{ whiteSpace: "nowrap" }}>
                                      {item.group_name}
                                    </span>
                                  </div>
                                  <div className="col-9">
                                    <div className="row">
                                      <div className="col-4">
                                      </div>
                                      <div className="col-4">
                                        <span className="font-mont-m fs-10 ">
                                          {item.count_finish_job}
                                        </span>
                                      </div>
                                      <div
                                        className="col-4"
                                        style={{ textAlign: "center" }}
                                      >
                                        <span className="font-mont-m fs-10 ">
                                          {item.percent_sla}
                                          {"%"}
                                        </span>
                                      </div>

                                    </div>
                                  </div>
                                  <div
                                    className="col-12"
                                  >
                                    <Progress percent={item.percent_sla} showInfo={false} />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="ant-col ant-col-xs-24 ant-col-xl-24" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                            <div className="card-dashboard">
                              <h3
                                className="font-mont-sb fs-16 c-blue"
                                style={{ borderBottom: "1px solid" }}
                              >
                                On time SLA rate : Team
                              </h3>
                              <div className="row mt-2">
                                <div className="col-6" style={{ textAlign: "left" }}>
                                  <span className="font-mont-m fs-10 c-blue ">
                                    Claim{" "}
                                  </span>
                                </div>
                                <div className="ant-col ant-col-xs-24 ant-col-xl-12" style={{ textAlign: "right" ,  paddingLeft: "15px", paddingRight: "15px"}}>
                                  <span className="font-mont-m fs-10 ">
                                    On Time SLA
                                  </span>
                                </div>
                              </div>
                              {this.state.data_sla_claim.map((item, index) => (
                                <div
                                  className="row mt-1"
                                  style={{
                                    background:
                                      "linear-gradient(90deg,  #37AB74 " +
                                      item.progess_sla +
                                      "%, #DDF1E7 " +
                                      (100 - item.progess_sla) +
                                      "%)",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <div className="col-6" >
                                    <span
                                      className="font-mont-m fs-10 "
                                      style={{ color: "#464749" }}
                                    >
                                      {item.name}
                                    </span>
                                  </div>
                                  <div
                                    className="col-6"
                                    style={{ textAlign: "right", color: "#464749" }}
                                  >
                                    <span className="font-mont-m fs-10 ">
                                      {item.progess_sla}
                                      {"%"}
                                    </span>
                                  </div>
                                </div>
                              ))}

                              <div className="row mt-2">
                                <div className="col-6" style={{ textAlign: "left" }}>
                                  <span className="font-mont-m fs-10 c-blue ">
                                    QC&Photo{" "}
                                  </span>
                                </div>
                                <div className="col-6" style={{ textAlign: "right" }}>
                                  <span className="font-mont-m fs-10 ">
                                    On Time SLA
                                  </span>
                                </div>
                              </div>
                              {this.state.data_sla_photo.map((item, index) => (
                                <div
                                  className="row mt-1"
                                  style={{
                                    background:
                                      "linear-gradient(90deg,  #37AB74 " +
                                      item.progess_sla +
                                      "%, #DDF1E7 " +
                                      (100 - item.progess_sla) +
                                      "%)",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <div className="col-6">
                                    <span
                                      className="font-mont-m fs-10 "
                                      style={{ color: "#464749" }}
                                    >
                                      {item.name}
                                    </span>
                                  </div>
                                  <div
                                    className="col-6"
                                    style={{ textAlign: "right", color: "#464749" }}
                                  >
                                    <span className="font-mont-m fs-10 ">
                                      {item.progess_sla}
                                      {"%"}
                                    </span>
                                  </div>
                                </div>
                              ))}
                              <div className="row mt-2">
                                <div className="col-6" style={{ textAlign: "left" }}>
                                  <span className="font-mont-m fs-10 c-blue ">
                                    Report
                                  </span>
                                </div>
                                <div className="col-6" style={{ textAlign: "right" }}>
                                  <span className="font-mont-m fs-10 ">
                                    On Time SLA
                                  </span>
                                </div>
                              </div>
                              {this.state.data_sla_report.map((item, index) => (
                                <div
                                  className="row mt-1"
                                  style={{
                                    background:
                                      "linear-gradient(90deg,  #37AB74 " +
                                      item.progess_sla +
                                      "%, #DDF1E7 " +
                                      (100 - item.progess_sla) +
                                      "%)",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <div className="col-6">
                                    <span
                                      className="font-mont-m fs-10 "
                                      style={{ color: "#464749" }}
                                    >
                                      {item.name}
                                    </span>
                                  </div>
                                  <div
                                    className="col-6"
                                    style={{ textAlign: "right", color: "#464749" }}
                                  >
                                    <span className="font-mont-m fs-10 ">
                                      {item.progess_sla}
                                      {"%"}
                                    </span>
                                  </div>
                                </div>
                              ))}

                              <div className="row mt-2">
                                <div className="col-6" style={{ textAlign: "left" }}>
                                  <span className="font-mont-m fs-10 c-blue ">
                                    Post
                                  </span>
                                </div>
                                <div className="col-6" style={{ textAlign: "right" }}>
                                  <span className="font-mont-m fs-10 ">
                                    On Time SLA
                                  </span>
                                </div>
                              </div>
                              {this.state.data_sla_post.map((item, index) => (
                                <div
                                  className="row mt-1"
                                  style={{
                                    background:
                                      "linear-gradient(90deg,  #37AB74 " +
                                      item.progess_sla +
                                      "%, #DDF1E7 " +
                                      (100 - item.progess_sla) +
                                      "%)",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <div className="col-6">
                                    <span
                                      className="font-mont-m fs-10 "
                                      style={{ color: "#464749" }}
                                    >
                                      {item.name}
                                    </span>
                                  </div>
                                  <div
                                    className="col-6"
                                    style={{ textAlign: "right", color: "#464749" }}
                                  >
                                    <span className="font-mont-m fs-10 ">
                                      {item.progess_sla}
                                      {"%"}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="card-dashboard">
                              <h3
                                className="font-mont-sb fs-16 c-blue"
                                style={{ borderBottom: "1px solid" }}
                              >
                                Top 10 Asset Maintenance
                              </h3>
                              <div className="row">
                                <div className="col-auto table-responsive p-0">
                                  <table className="table table-borderless" style={{ lineHeight: "1" }}>
                                    <thead>
                                      <tr style={{ color: "#0510A3" }}>
                                        {/* <th scope="col">No.</th> */}
                                        <th scope="col">Code</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Group</th>
                                        <th
                                          scope="col"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          Total Jobs
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.data_top_asset.map((item, index) => (
                                        <tr>
                                          {/* <th scope="row">{item.no}</th> */}
                                          <td className="tdoverflowCode">
                                            <Tooltip title={item.asset_code}>
                                              <span>     {item.asset_code}</span>
                                            </Tooltip>

                                          </td>
                                          <td style={{ color: "#0510A3" }} className="tdoverflow">
                                            <Tooltip title={item.asset_name}>
                                              <span>     {item.asset_name}</span>
                                            </Tooltip>
                                          </td>
                                          <td className="tdoverflow">
                                            <Tooltip title={item.asset_type_name}>
                                              <span>     {item.asset_type_name}</span>
                                            </Tooltip>
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            <Tooltip title={item.total_jobs}>
                                              <span>     {item.total_jobs}</span>
                                            </Tooltip>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Spin>
          </>
          : null}
      </>
    );
  }
}

export default Dashboard;
